var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraditionalPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "74px",
    viewBox: "0 0 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EA6FA1A0-05F4-4CD6-898B-D859C621EB40") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dealer-success-program",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dealer-support-desktop",
    transform: "translate(-381.000000, -585.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(346.000000, 550.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "traditional-print",
    transform: "translate(36.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4137931,65.7931034 L12.4137931,45.9310345 L2,45.9310345 C0.8954305,45.9310345 7.17316882e-15,46.826465 7.30843957e-15,47.9310345 L7.30843957e-15,65.7931034 L7.30843957e-15,65.7931034 C7.30843957e-15,69.2205517 2.77944828,72 6.20689655,72 C9.63434483,72 12.4137931,69.2205517 12.4137931,65.7931034 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4137931,59.5862069 L12.4137931,29.7931034 L12.4137931,2.48275862 C12.4137931,1.11103448 13.5248276,0 14.8965517,0 L69.5172414,0 C70.8889655,0 72,1.11103448 72,2.48275862 L72,65.7931034 C72,69.2205517 69.2205517,72 65.7931034,72 L6.20689655,72 C9.63434483,72 12.4137931,69.2205517 12.4137931,65.7931034 L12.4137931,59.5862069 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.635468,30.1344828 L60.7783251,30.1344828 C61.8828946,30.1344828 62.7783251,29.2390523 62.7783251,28.1344828 L62.7783251,11.0487685 C62.7783251,9.94419897 61.8828946,9.04876847 60.7783251,9.04876847 L23.635468,9.04876847 C22.5308985,9.04876847 21.635468,9.94419897 21.635468,11.0487685 L21.635468,28.1344828 C21.635468,29.2390523 22.5308985,30.1344828 23.635468,30.1344828 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.635468,45.9310345 L27.0837438,45.9310345 C28.1883133,45.9310345 29.0837438,45.035604 29.0837438,43.9310345 L29.0837438,40.4827586 C29.0837438,39.3781891 28.1883133,38.4827586 27.0837438,38.4827586 L23.635468,38.4827586 C22.5308985,38.4827586 21.635468,39.3781891 21.635468,40.4827586 L21.635468,43.9310345 C21.635468,45.035604 22.5308985,45.9310345 23.635468,45.9310345 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.8758621,
    y1: 38.4827586,
    x2: 62.8758621,
    y2: 38.4827586,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.8758621,
    y1: 44.6896552,
    x2: 45.8758621,
    y2: 44.6896552,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.8758621,
    y1: 55.8221675,
    x2: 62.8758621,
    y2: 55.8221675,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.8758621,
    y1: 62.029064,
    x2: 45.8758621,
    y2: 62.029064,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.635468,62.6896552 L27.0837438,62.6896552 C28.1883133,62.6896552 29.0837438,61.7942247 29.0837438,60.6896552 L29.0837438,57.2413793 C29.0837438,56.1368098 28.1883133,55.2413793 27.0837438,55.2413793 L23.635468,55.2413793 C22.5308985,55.2413793 21.635468,56.1368098 21.635468,57.2413793 L21.635468,60.6896552 C21.635468,61.7942247 22.5308985,62.6896552 23.635468,62.6896552 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraditionalPrint);
export default __webpack_public_path__ + "static/media/traditional-print.e944ca56d55585d5bcaa298de89ece0f.svg";
export { ForwardRef as ReactComponent };